module.exports = __webpack_public_path__ + "static/media/icon.7aa0cd16.png";